<template>
  <div class="content" v-if="rendered">
    <div class="row">
      <div class="col-12">
        <input type="file" @change="handleFileUpload" />
      </div>
    </div>
  </div>
  <div v-else>
    <div class="loading-overlay">
      <span class="fas fa-spinner fa-3x fa-spin"></span>
    </div>
  </div>
</template>
<script>
import Papa from "papaparse";
import { Select, Option } from "element-ui";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import api from "../api/index";
import { Modal, BaseInput } from "@/components/index";
import axios from "axios";

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();
export default {
  components: {
    FullCalendar,
    Modal,
    BaseInput,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      rendered: false,
      events: [],
      modals: {
        classic: false,
      },
      restaurantes: [],
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        theme: true,
        defaultView: "dayGridMonth",
        header: {
          left: "title",
          center: "dayGridMonthy",
          right: "prev,next,today",
        },
        defaultDate: today,
        selectable: true,
        selectHelper: true,
        views: {
          month: {
            titleFormat: {
              month: "long",
              year: "numeric",
            },
          },
        },
        editable: false,
        eventLimit: true,
        events: self.events,
      },
      dataParaEventos: {
        start: "",
        end: "",
      },
      novoEvento: {
        data_inicio: "",
        data_fim: "",
        restaurante: "",
        titulo: "",
      },
      admin: "0",
    };
  },
  methods: {
    notifyVue(verticalAlign, horizontalAlign, color, mensagem) {
      this.$notify({
        icon: "tim-icons icon-bell-55",
        message: mensagem,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: color,
        timeout: 2000,
      });
    },

    async criarEvento() {
      if (
        this.novoEvento.titulo.trim() == "" ||
        this.novoEvento.restaurante.trim() == ""
      ) {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "Tem de preencher todos os campos"
        );
        return;
      }
      let res = await api.criarEvento(this.novoEvento);
      if (res.resultado == "OK") {
        this.events.push({
          start: this.dataParaEventos.start,
          end: this.dataParaEventos.end,
          url: "",
          className: "event-orange",
          title: this.novoEvento.titulo,
        });
        this.notifyVue("top", "right", "success", "O evento foi criado");
        this.novoEvento = {
          data_inicio: "",
          data_fim: "",
          restaurante: "",
          titulo: "",
        };
        this.modals.classic = false;
        return;
      } else {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "Ocorreu um erro, por favor tente mais tarde"
        );
        return;
      }
    },

    formatarDataEvento(data, sub) {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate() - sub).padStart(2, "0");
      const dataFormatada = `${ano}-${mes}-${dia}`;
      return dataFormatada;
    },

    async inicio() {
      this.rendered = false;

      var user = JSON.parse(localStorage.getItem("appGerenciaLogin"));
      let resUser = await api.listarRestaurante({
        user_id: user.user_id,
      });
      this.admin = resUser.resultado.admin == "1" ? true : false;
      this.calendarOptions.selectable = this.admin;
      var json = {
        restaurante: user.nome,
        admin: resUser.resultado.admin,
      };
      let res = await api.listarEventos(json);
      var eventos = Object.values(res.resultado);
      const classesDisponiveis = [
        "event-azure",
        "event-green",
        "event-orange",
        "event-red",
        "event-rose",
        "event-default",
      ];
      if (eventos.length > 0) {
        const eventosParaFullCalendar = eventos.map((evento) => {
          // Seleciona uma classe aleatória
          const classeAleatoria =
            classesDisponiveis[
              Math.floor(Math.random() * classesDisponiveis.length)
            ];

          return {
            title: this.admin
              ? evento.restaurante + " " + evento.titulo
              : evento.titulo,
            start: new Date(evento.data_inicio),
            end: new Date(evento.data_fim),
            url: "",
            className: classeAleatoria, // Atribui a classe aleatória
          };
        });

        this.events = eventosParaFullCalendar;
      }
      // IR BUSCAR RESTAURANTES
      var resRestaurantes = await api.listarRestaurantes();
      var tempRest = Object.values(resRestaurantes.resultado);
      for (let i = 0; i < tempRest.length; i++) {
        this.restaurantes.push({
          label: tempRest[i].nome,
          value: tempRest[i].nome,
        });
      }
      this.restaurantes.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      this.rendered = true;
    },

    async onSelect({ start, end }) {
      this.dataParaEventos.start = start;
      this.dataParaEventos.end = end;
      this.novoEvento.data_inicio = this.formatarDataEvento(start, 0);
      this.novoEvento.data_fim = this.formatarDataEvento(end, 1);
      console.log(this.novoEvento);
      this.modals.classic = true;
    },
    async processRecords(validRecords) {
      this.rendered = false;
      for (let i = 0; i < validRecords.length; i++) {
        var temp = {
          "contribuinte": validRecords[i].NIF,
          "data": validRecords[i].redeemAt.split("T")[0],
          "data_visita": validRecords[i].redeemAt.split("T")[0],
          "restaurante": validRecords[i].storeName,
          "email": validRecords[i].Email,
          "nome": validRecords[i].Nome,
          "telefone": validRecords[i].Telefone,
        };

        console.log(temp, i);

        let data = JSON.stringify(temp);

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://api.republica45.pt/zonsoft/index.php",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        try {
          const response = await axios.request(config);

          if (response.data.indexOf("OK") > -1) {
            this.notifyVue(
              "top",
              "right",
              "success",
              "NIF " + validRecords[i].NIF + " atualizado!"
            );
          } else {
            this.notifyVue(
              "top",
              "right",
              "warning",
              "Problema ao atualizar o nif " + validRecords[i].NIF
            );
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.rendered = true;
    },

    handleFileUpload(event) {
      var _this = this;
      const file = event.target.files[0];
      if (file) {
        Papa.parse(file, {
          header: true, // Assumes your CSV has headers
          complete: (results) => {
            const cleanedData = results.data.map((record) => {
              const cleanedRecord = {};

              for (const key in record) {
                if (record.hasOwnProperty(key)) {
                  // Remove the wrapping =" and " if they exist
                  cleanedRecord[key] = record[key].replace(/^="(.+)"$/, "$1");
                }
              }

              return cleanedRecord;
            });
            const validRecords = cleanedData.filter((record) => {
              return (
                record.passId && record.Nome && record.NIF && record.redeemAt
              );
            });
            this.processRecords(validRecords);
          },
          error: (error) => {
            console.error(error.message);
          },
        });
      }
    },
  },
  async mounted() {
    await this.inicio();
  },
};
</script>
<style>
#fullCalendar {
  min-height: 400px;
}

.el-loading-spinner .path {
  stroke: #66615b !important;
}
</style>
